import React, { useState } from "react";
import "./styles/AddRecipeCardStyle.css";
import ImageUpload from "./components/ImageUpload";
import VideoUpload from "./components/VideoUpload";
import IngredientInputs from "./components/IngredientInputs";
import StepsInputs from "./components/StepsInputs";
import TagsForm from "./components/TagsForm";
import TopNavbarBack from "../../components/TopNavbarBack";
import "../../styles/Containers.css";
import { useFetch } from "../../custom/api";

// import { formData } from '@fatcherjs/middleware-form-data';

function AddCard() {
  const { myFetch } = useFetch();
  const [tags, setTags] = useState([]);
  const [name, setName] = useState("");
  const [duration, setduration] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [ingredients, setIngredients] = useState([{ ingName: "", ingVol: "" }]);
  const [steps, setSteps] = useState([{ description: "" }]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("food_name", name);
    formData.append("cooking_duration", duration);
    formData.append("ingredients", JSON.stringify(ingredients));
    formData.append("recipe", JSON.stringify(steps));
    formData.append("tags", JSON.stringify(tags));
    formData.append("image", image);
    formData.append("video", video);
    formData.append("price", price);

    let data = await myFetch('add', {
      method: "POST",
      body: formData,
    });
  };

  return (
    <>
      <div className="backLightColor">
        <TopNavbarBack
          title=""
          rbuttonIcon={["icon-iconchevron-right"]}
          rbackground={["rectangle1"]}
          lbuttonIcon={["dNone"]}
          lbuttonHref={["null"]}
          lbackground={["null"]}
        />

        <div className="main-container rtl">
          <h2>اضافه کردن کارت غذا</h2>

          <div>
            <label>
              نام
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </label>

            <div className="marginBottom2r"></div>

            <label>
              زمان پخت "دقیقه"
              <input
                type="number"
                name="duration"
                value={duration}
                onChange={(e) => {
                  setduration(e.target.value);
                }}
              />
            </label>

            <div className="marginBottom2r"></div>

            <label>
              مواد اولیه
              <IngredientInputs
                ingredients={ingredients}
                setIngredients={setIngredients}
              />
            </label>

            <div className="marginBottom2r"></div>

            <label>
              مراحل
              <StepsInputs steps={steps} setSteps={setSteps} />
            </label>

            <div className="marginBottom2r"></div>

            <label>
              تگ‌ها
              <TagsForm tags={tags} setTags={setTags} />
            </label>

            <div className="marginBottom2r"></div>

            <label>
              رسانه
              <ImageUpload image={image} setImage={setImage} />
              <VideoUpload video={video} setVideo={setVideo} />
            </label>

            <div className="marginBottom2r"></div>

            <label>
              قیمت "تومان"
              <input
                type="text"
                name="price"
                value={price}
                onChange={(e) => {
                  setPrice(e.target.value);
                }}
              />
            </label>

            <div className="marginBottom2r"></div>

            <button onClick={handleSubmit} type="submit">
              ثبت کارت غذا
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCard;
